export const FIREBASE_EMULATOR_ENDPOINTS = Object.freeze({
  auth: Object.freeze({ host: '127.0.0.1', port: 9099 }),
  firestore: Object.freeze({ host: '127.0.0.1', port: 8080 }),
  database: Object.freeze({ host: '127.0.0.1', port: 9000 }),
  storage: Object.freeze({ host: '127.0.0.1', port: 9199 }),
  functions: Object.freeze({ host: '127.0.0.1', port: 5001 }),
});

export const resolveFirebaseEmulatorConfig = ({
  environment = process.env.REACT_APP_SISDP_ENVIRONMENT,
  useEmulators = process.env.REACT_APP_E2E_USE_EMULATORS,
} = {}) => {
  const normalizedEnvironment = String(environment || 'PRODUCTION').trim().toUpperCase();

  if (normalizedEnvironment !== 'E2E') {
    return { enabled: false, endpoints: FIREBASE_EMULATOR_ENDPOINTS };
  }

  if (String(useEmulators || '').trim().toLowerCase() !== 'true') {
    throw new Error('[SISDP E2E] Execução bloqueada: os emuladores Firebase são obrigatórios.');
  }

  return { enabled: true, endpoints: FIREBASE_EMULATOR_ENDPOINTS };
};
